import { useMutation, useQuery } from "react-query";
import isEmpty from "lodash/isEmpty";
import omit from "lodash/omit";
import reject from "lodash/reject";

import { gwtClient } from "@monta/utils";

import type { QueryKey } from "react-query";
import type { PostMediaRequest } from "./media-request.types";

export const postMediaRequest = {
  url: () => `/exam/requestMediaInsertUpdate`,
  fn: async (request: PostMediaRequest["request"]) => {
    const { data } = await gwtClient<PostMediaRequest["response"]>({
      ...request?.axiosConfig,
      method: "POST",
      url: postMediaRequest.url(),
      data: request.body,
    });
    return data;
  },
  key: (request: PostMediaRequest["request"]) => {
    return reject(
      [postMediaRequest.url(), omit(request ?? {}, "axiosConfig")],
      isEmpty,
    ) as QueryKey;
  },
  query: (options: PostMediaRequest["queryOptions"]) => ({
    ...options.queryOptions,
    queryKey: postMediaRequest.key(options.request),
    queryFn: () => postMediaRequest.fn(options.request),
  }),
  useQuery: (options: PostMediaRequest["queryOptions"]) =>
    useQuery(postMediaRequest.query(options)),
  useMutation: (options?: PostMediaRequest["mutationOptions"]) =>
    useMutation({
      ...options,
      mutationFn: postMediaRequest.fn,
    }),
};
